import React from "react";
import firebase from "firebase/app";
import firebaseConfig from "./firebase.config";
import "firebase/auth";
import { useHistory, useLocation } from "react-router";

const Login = () => {
  if (firebase.apps.length === 0) {
    firebase.initializeApp(firebaseConfig);
  }

  const history = useHistory();
  const location = useLocation();
  const [error, setError] = "";
  const { from } = location.state || { from: { pathname: "/" } };

  const handleGoogleSignIn = () => {
    var provider = new firebase.auth.GoogleAuthProvider();
    firebase
      .auth()
      .signInWithPopup(provider)
      .then((result) => {
        const user = result.user;
        const loggedInUser = {
          name: user.displayName,
          email: user.email,
          img: user.photoURL,
        };
        localStorage.setItem("user", JSON.stringify(loggedInUser));
        history.replace(from);
      })
      .catch((error) => {
        const errorMessage = error.message;
        setError(errorMessage);
      });
  };

  return (
    <div>
      <div className="container">
        <div className="text-center">
          <button onClick={handleGoogleSignIn} className="btn btn-primary m-5">
            {" "}
            Google Sign In
          </button>
          <p>{error}</p>
        </div>
      </div>
    </div>
  );
};

export default Login;
